// Global
import { JSX } from 'react';

// Local
import { REMIXICON_CONSTANTS } from 'helpers/Constants/SiteConfig';

/**
 * Symbols that have to be resolvable at first paint.
 *
 * `RemixSpriteLoader` fetches the full 1.6 MB sprite inside an effect, so it cannot land until
 * after hydration — until then every `<use href="#ri-…">` renders an empty box. Icons that are
 * part of the initial layout (today: the header's mega-menu chevrons) are therefore inlined
 * here instead. This component is server-rendered, so the symbols ship in the HTML for a few
 * hundred bytes and paint with the markup rather than a second later.
 *
 * Keep the list short — it exists for above-the-fold icons only. Everything else, including the
 * icons authors pick in Sitecore, still comes from the full sprite.
 */
const CRITICAL_SYMBOLS: { id: string; path: string }[] = [
  {
    id: 'ri-arrow-down-s-line',
    path: 'M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z',
  },
  {
    id: 'ri-arrow-up-s-line',
    path: 'M11.9999 10.8284L7.0502 15.7782L5.63599 14.364L11.9999 8L18.3639 14.364L16.9497 15.7782L11.9999 10.8284Z',
  },
];

export const RemixIconCriticalSprite = (): JSX.Element => (
  <>
    {/*
     * Starts the full sprite downloading during HTML parse instead of after hydration, so the
     * icons that are not inlined below also appear sooner. React hoists this into <head>.
     */}
    <link as="fetch" href={REMIXICON_CONSTANTS.spriteImageUrl} rel="preload" type="image/svg+xml" />
    <svg aria-hidden="true" height="0" style={{ display: 'none' }} width="0">
      {CRITICAL_SYMBOLS.map(({ id, path }) => (
        <symbol id={id} key={id} viewBox="0 0 24 24">
          <path d={path} />
        </symbol>
      ))}
    </svg>
  </>
);

export default RemixIconCriticalSprite;
